import React from "react";
import label from "../../labels/postExaminationProcessObjective_en.json";

const ResultGeneration = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.ResultGeneration} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default ResultGeneration;
